export default function getResource(label, vars = []) {
    const resources = {
        // Landing CTAs (different label per channel per Figma).
        ctaMobile: 'Get Started',
        ctaDesktop: 'Link Sephora & Starbucks Accounts',
        accountLinked: 'Account linked',
        // Post-link shop actions (small UI). The "How Do I earn…" heading and step
        // cards are CMS-driven (BannerList sid Sephoraxstarbucks_HowtoEArn_bannerlist).
        shopOnline: 'Shop Online',
        shopMyStore: 'Shop My Store',
        // Linked-state links.
        manageLinkedAccounts: 'Manage your linked accounts',
        seeAllPointsActivity: 'See all points activity',
        // Terms row. The terms URL is in constants (TERMS_URL).
        termsLinkLabel: 'See applicable program Terms & Conditions',
        termsBody: '',
        // Link Account modal (title falls back here if CMS omits it).
        linkModalTitle: 'Link Account',
        linkModalSubtitle: 'Notice and Consent',
        linkModalBody:
            'To participate in the Starbucks Sephora loyalty initiative, you must link your ' +
            'Starbucks™ account to your Sephora account associated with a U.S. phone number, and ' +
            'your account must be in good standing. Once you link your accounts, you can earn ' +
            'Starbucks Points on Qualifying Transactions. By linking your account, you consent to ' +
            'Sephora sharing your purchase details with Starbucks. If you no longer wish to ' +
            'participate in this offer, you may unlink your account at any time in the Sephora app.',
        linkModalCheckbox: 'I have read & agree to Terms of Use.',
        linkModalSubmit: 'Link Account',
        // Link-failure popup (Figma 3132-74072).
        linkErrorBody: 'Unable to link your account at the moment. Please try again.',
        linkErrorDismiss: 'Ok'
    };

    return resources[label];
}
